import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g id="J" transform="translate(22.000000, 18.000000)">
          <path
            d="M 20.4 38.32 L 20.4 0 L 28 0 L 28 37.52 A 39.36 39.36 0 0 1 27.815 41.442 Q 27.545 44.135 26.88 46.32 A 19.204 19.204 0 0 1 25.668 49.384 A 14.032 14.032 0 0 1 23.68 52.36 Q 21.6 54.72 18.72 55.84 Q 15.84 56.96 12.32 56.96 A 18.754 18.754 0 0 1 5.858 55.854 A 17.924 17.924 0 0 1 5.4 55.68 A 18.262 18.262 0 0 1 2.262 54.094 A 14.547 14.547 0 0 1 0 52.32 L 3.68 46.48 A 13.487 13.487 0 0 0 6.936 48.973 A 15.544 15.544 0 0 0 7.52 49.28 A 10.491 10.491 0 0 0 10.62 50.288 A 9.553 9.553 0 0 0 12.08 50.4 A 8.739 8.739 0 0 0 14.836 49.985 A 7.146 7.146 0 0 0 18.16 47.68 Q 20.127 45.291 20.367 39.879 A 35.288 35.288 0 0 0 20.4 38.32 Z"
            fill="currentColor"
          />
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
